import { render, staticRenderFns } from "./message-container.vue?vue&type=template&id=cebee096&scoped=true"
import script from "./message-container.vue?vue&type=script&lang=ts"
export * from "./message-container.vue?vue&type=script&lang=ts"
import style0 from "./message-container.vue?vue&type=style&index=0&id=cebee096&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebee096",
  null
  
)

export default component.exports